import React, { Component } from "react";
import { Checkbox } from "antd";
import "styles/SelectFilter.scss";
import { UpOutlined, DownOutlined } from "@ant-design/icons";
const CheckboxGroup = Checkbox.Group;

export default class AreaFilterMobile extends Component {
  state = {
    expanded: false,
    mobileExpanded: false,
    selected: [],
  };

  renderAreaOptions = () => {
    const { fieldsOfStudy } = this.props;
    const instOptions = Object.values(fieldsOfStudy)
      .sort((a, b) =>
        a.description.toLowerCase() < b.description.toLowerCase() ? -1 : 1
      )
      .map(({ fos_code, description }) => (
        <Checkbox
          key={fos_code}
          value={fos_code}
          className="select-filter-checkbox"
        >
          <div className="indented">{description}</div>
        </Checkbox>
      ));
    return instOptions;
  };

  toggleMobileDropdown = () =>
    this.setState({ mobileExpanded: !this.state.mobileExpanded });

  applyFilter = () => {
    const { onChange } = this.props;
    onChange(this.state.selected);
    this.setState({ mobileExpanded: false }, () => {
      this.mobileFilter.scrollIntoView();
    });
  };

  renderMobileDropDown = () => {
    const { onChange, selected } = this.props;
    return (
      <div
        ref={(element) => {
          this.mobileDropdown = element;
        }}
      >
        <CheckboxGroup
          onChange={onChange}
          value={selected}
          className="filter-checkbox-group"
        >
          {this.renderAreaOptions()}
        </CheckboxGroup>
      </div>
    );
  };

  render() {
    const { selected } = this.props;
    return (
      <>
        <div
          className="select-filter-container mobile-only"
          ref={(element) => {
            this.mobileFilter = element;
          }}
        >
          <div
            className="select-filter-button"
            onClick={this.toggleMobileDropdown}
          >
            <h1 className="select-filter-title">
              Study Areas
              {selected.length > 0 && (
                <div className="number-selected-tag">{selected.length}</div>
              )}
            </h1>
            {this.state.mobileExpanded ? <UpOutlined /> : <DownOutlined />}
          </div>
        </div>
        {this.state.mobileExpanded && this.renderMobileDropDown()}
      </>
    );
  }
}
